import React from 'react';
import { Link } from 'react-router-dom';
import TallyEmbed from '../components/TallyEmbed';

const ApplyMentee = () => (
  <div className="min-h-screen bg-cream" data-testid="apply-mentee-page">
    {/* Hero Section */}
    <section className="bg-cream pt-28 sm:pt-32 md:pt-36 pb-12 md:pb-16 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <Link
          to="/apply"
          className="inline-flex items-center gap-2 text-dark-green/70 hover:text-dark-green font-mono tracking-[0.2em] uppercase text-xs sm:text-sm mb-8 transition-colors"
        >
          <span aria-hidden>&larr;</span> Back to Apply
        </Link>
        <p className="text-dark-green/60 font-mono tracking-[0.25em] text-xs sm:text-sm uppercase mb-5">
          <span className="text-dark-green/40">&rarr;</span> Apply &middot; Mentee
        </p>
        <h1 className="font-serif text-4xl sm:text-5xl md:text-7xl lg:text-8xl leading-tight tracking-tight mb-8 max-w-6xl">
          <span className="text-gradient-hero">Become a</span>
          <br />
          <span className="text-gradient-hero-light italic">Mentee.</span>
        </h1>
        <p className="text-dark-green/75 text-lg sm:text-xl md:text-2xl leading-snug max-w-3xl">
          Your chance to be part of an exclusive network of dharmic professionals, gaining the mentorship of hyper-successful professionals via a host of mediums! We'd love to have you onboard.
        </p>
      </div>
    </section>

    {/* Form Section */}
    <section className="bg-cream pb-20 md:pb-28 px-4 sm:px-6 border-t border-dark-green/10 pt-14 sm:pt-18 md:pt-22">
      <div className="max-w-3xl mx-auto">
        <div className="mb-10 md:mb-12">
          <p className="text-dark-green/60 font-mono tracking-[0.25em] text-xs sm:text-sm uppercase mb-3">
            <span className="text-dark-green/40">&rarr;</span> 01 / Application
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-dark-green leading-tight max-w-3xl">
            Tell us about you.
          </h2>
        </div>
        <TallyEmbed formId="lbdAep" title="Mentee Application Form" />
      </div>
    </section>
  </div>
);

export default ApplyMentee;
